import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./Countries.css";

const countriesList = [
  {
    flag: require("../../../assets/homepage/countries/russia.png"),
    name: "Russia",
  },
  {
    flag: require("../../../assets/homepage/countries/japan.png"),
    name: "Japan",
  },
  {
    flag: require("../../../assets/homepage/countries/usa.png"),
    name: "USA",
  },
  {
    flag: require("../../../assets/homepage/countries/italy.png"),
    name: "Italy",
  },
  {
    flag: require("../../../assets/homepage/countries/germany.png"),
    name: "Germany",
  },
  {
    flag: require("../../../assets/homepage/countries/southKorea.png"),
    name: "South Korea",
  },
  {
    flag: require("../../../assets/homepage/countries/vietnam.png"),
    name: "Vietnam",
  },
  {
    flag: require("../../../assets/homepage/countries/indiaflag.png"),
    name: "India",
  },
];

const Countries = () => {
  const [swiperRef, setSwiperRef] = useState(null);

  return (
    <div className="max-w-[1241px] m-auto my-[35px] px-[16px] md:px-[24px] lg:px-0 flex flex-col">
      <div className="w-[200px] h-[35px]">
        <h3 className="lg:text-[20px] md:text-[16px] text-[14px] font-semibold leading-[30px] w-[300px] h-[30px] md:w-[350px] lg:w-[400px] text-[#323232] select-none">
          Find Suppliers by Country or Region
        </h3>
      </div>
      <hr className="bg-[#FF8100] w-[211px] md:w-[200px] lg:w-[400px] h-[4px] rounded-full md:mt-[10px]" />
      <div className="flex md:w-full flex-col mt-[18px] lg:mt-[23px] justify-center items-center rounded-[10px] max-w-[1241px] m-auto lg:h-[250px] w-full h-[99px] md:h-[156px] bg-white border">
        <Swiper
          onSwiper={setSwiperRef}
          slidesPerView={7}
          spaceBetween={20}
          navigation={true}
          modules={[Navigation]}
          className="thisIsSwiper"
        >
          {countriesList.map((item, index) => (
            <div key={index}>
              <SwiperSlide className="countrySwiperSlide">
                <img
                  src={item.flag}
                  className="h-[36px] w-[36px] md:w-[65px] md:h-[65px]"
                  alt="countryImg"
                />
                <p className="w-auto text-center text-[#323232] md:text-black font-medium text-[12px] md:text-[14px] lg:font-semibold lg:text-[16px] mt-[4px] lg:mt-[35px]">
                  {item.name}
                </p>
              </SwiperSlide>
            </div>
          ))}
        </Swiper>
        <div className="hidden md:flex justify-center items-center">
          <button>
            <p className="font-[600] text-[#ff6300]">View more</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Countries;
